import { IconButton, useColorMode, Tooltip } from '@chakra-ui/react';
import { Sun, Moon } from '@phosphor-icons/react';

export const ColorModeToggle = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Tooltip label={colorMode === 'light' ? 'Dark mode' : 'Light mode'}>
      <IconButton
        aria-label="Toggle color mode"
        icon={colorMode === 'light' ? <Moon weight="duotone" /> : <Sun weight="duotone" />}
        onClick={toggleColorMode}
        variant="ghost"
        color="text.muted"
        _hover={{ color: 'text.default', bg: 'bg.subtle' }}
        size="lg"
      />
    </Tooltip>
  );
}; 